// The resume code is an 8-char ambiguity-free string displayed as XXXX-XXXX (§7).
export const formatRecoveryCode = (code) => {
  if (!code) return null;
  const clean = code.replace(/-/g, "").toUpperCase();
  if (clean.length !== 8) return clean;
  return `${clean.slice(0, 4)}-${clean.slice(4)}`;
};

// Normalize user input for submission: strip the dash + spaces, upper-case (§7 accepts
// the code with/without the dash and any case).
export const normalizeRecoveryCode = (code) => (
  (code || "").replace(/[\s-]/g, "").toUpperCase()
);
